import { useAct } from 'FlowTaker/store'
import DonateForm from 'FlowBuilder/components/ActionViews/Donate/DonateForm'
import TemplateRender from 'FlowBuilder/components/ActionViews/TemplateRender'
import useRenderContext from 'FlowTaker/hooks/useRenderContext'
import SignatureCount from 'FlowBuilder/components/ActionViews/Survey/SignatureCount'

export default function DonateAction({ actionId, surveyId }) {
  const act = useAct()
  const bodyHtml = useSel(s => s.taker.flow.template.body)
  const publicUrl = useSel(s => s.taker.flow.publicUrl)
  const context = useRenderContext({ actionId })
  const action = useSel(s => s.taker.flow.actions.find(a => a.id === actionId) || {})
  const targetDetails = useSel(s => s.taker?.targetDetails || {})

  const handleSubmit = (data) => {
    return act.taker.completeAction({ actionId, actionParams: data })
  }

  const onUpdateNoTarget = () => {
    return act.taker.updateNoTarget()
  }

  const componentMap = useMemo(() => ({
    TakeSurveyForm: <>
      <DonateForm
        action={action}
        onSubmit={handleSubmit}
        publicUrl={publicUrl}
        targetDetails={targetDetails}
        onUpdateNoTarget={onUpdateNoTarget}
      />
    </>,
    SignatureCount: <>
      <SignatureCount actionId={actionId} />
    </>,
  }), [surveyId, targetDetails])

  return <div>
    <TemplateRender htmlContent={bodyHtml} componentMap={componentMap} context={context} />
  </div>
}
